
import { z } from "zod";

export const UploadCompletedWorkPhotosAttemptTypeValues = ["UPLOAD", "REQUEST"] as const;
export const UploadCompletedWorkPhotosAttemptTypeSchema = z.enum(UploadCompletedWorkPhotosAttemptTypeValues);
export const UploadCompletedWorkPhotosAttemptType = UploadCompletedWorkPhotosAttemptTypeSchema.enum;
export type UploadCompletedWorkPhotosAttemptType = (typeof UploadCompletedWorkPhotosAttemptTypeValues)[number];
